import styled from 'styled-components';
import { Dialog, DialogContent } from '@mui/material';

import { mixins, fonts, media } from '../../css';

export const StyledCloseButtonWrapper = styled.span`
  cursor: pointer;

  display: flex;
  justify-content: flex-end;
  figure {
    cursor: pointer;
  }
`;

export const StyledTitleHeader = styled.div`
  ${({ fullContent }) =>
    fullContent &&
    `position: absolute;
`};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ fullContent }) => (fullContent ? mixins.pxToRem(5) : mixins.pxToRem(24))};
  padding-bottom: ${({ fullContent }) => (fullContent ? 0 : mixins.pxToRem(10))};
  width: 100%;
  z-index: 10;
  flex-wrap: no-wrap;
  flex-direction: column;
  margin: 0;
  color: ${({ titleColor }) => titleColor};
`;

export const StyledIconeHeader = styled.div`
  ${({ fullContent }) =>
    fullContent &&
    `position: absolute;
`};
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  flex-wrap: no-wrap;
  flex-direction: column;
  margin: 0;
`;

export const StyledHeaderContainer = styled.div`
  ${({ fullContent }) =>
    fullContent &&
    `position: absolute;
`};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ fullContent }) => (fullContent ? mixins.pxToRem(5) : mixins.pxToRem(15))};
  padding-bottom: ${({ fullContent }) => (fullContent ? 0 : mixins.pxToRem(10))};
  width: 100%;
  flex-wrap: wrap;
  flex-direction: column;
  background: ${({ headerColor }) => headerColor};
`;

export const StyledTitle = styled.div`
  font-family: ${fonts.fontBold};
  font-size: ${mixins.pxToRem(18)};
`;

export const StyledSubTitle = styled.div`
  font-family: ${fonts.fontRegular};
  font-size: ${mixins.pxToRem(18)};
`;

export const StyledDialog = styled(Dialog)`
  && {
    [class^='MuiPaper-root'] {
      ${media.lessThan('md')`
        ${({ smallmodal }) =>
          smallmodal === 'false' &&
          `margin: 0;
          width: 100%;
          height: 100%;
          max-height: 100%;
        `};
      `};
      width: 800px;
    }
  }
`;

export const StyledIconWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  figure {
    cursor: pointer;
  }
  font-size: ${mixins.pxToRem(80)};
  color: ${({ iconColor }) => iconColor};
`;

export const StyledDialogContent = styled(DialogContent)`
  font-family: ${fonts.fontRegular};
  margin-top: 15px;
  &.fullContent {
    padding: 0;
  }
  &.noOverflow {
    overflow: visible !important;
  }
`;
